
export const name = "embedded-academy-ui";
export const version = "dev";
